import { render, staticRenderFns } from "./ContactAddressLabelSelect.vue?vue&type=template&id=0da430e6"
import script from "./ContactAddressLabelSelect.vue?vue&type=script&lang=js"
export * from "./ContactAddressLabelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports